import { useEffect, useRef } from 'react';
import { Images } from '@/assets/imgs';
import { BtnRed } from '@/components/Buttons';
import { ObserverContainer } from '@/components/ObserverContainer';
import { splitLines } from '@/modules/utils/utils';
import Image from 'next/image';
import { Tween } from 'react-gsap';
import { Scene } from 'react-scrollmagic';

export const CommunitySection = () => {
  const ref = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    if (ref.current) {
      splitLines(ref.current);
    }
  }, []);

  return (
    <div className="flex column start middle w-full community-section">
      <ObserverContainer className="flex column start middle ">
        <h2 className="integralfc-h2 reveal-from-bottom" ref={ref}>
          Backed by the community
        </h2>
        <p className="lexend-body-sm l">
          As well as business angels from Yield Guild Games, Aave, Lens,
          ESL/FaceIt and France Esports.
        </p>
      </ObserverContainer>
      {/*
      <BtnRed
        label="Register Interest"
        href="https://presale.xborg.com/register"
        className="lexend-body-md"
      />
      */}

      <div className="flex center middle cards-container">
        <div className="flex column center middle card-1">
          <p className="lexend-body-s">Raised over</p>
          <h2 className="integralfc-h2">$7 000 000</h2>
          <p className="lexend-body-sm l">
            from our community during our XBG seed round and presale
          </p>
          <Image
            src={Images.landing.sphere8}
            alt=""
            quality={100}
            width={92}
            height={92}
            className="sphere sphere1"
          />
        </div>
      </div>
      <Image
        src={Images.landing.sphere9}
        alt=""
        quality={100}
        width={92}
        height={92}
        className="sphere sphere2"
      />
    </div>
  );
};
